import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ParametroFuncao } from 'src/app/funcao/models/parametro-funcao';

@Component({
  selector: 'app-parametro-funcao-valor-inteiro',
  templateUrl: './parametro-funcao-valor-inteiro.component.html',
  styleUrls: ['./parametro-funcao-valor-inteiro.component.scss']
})
export class ParametroFuncaoValorInteiroComponent implements OnInit {

  constructor() { }

  @Input() schema: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    obrigatorioSe: [],
    variavel: "",
  };
  @Input() schemaParent: ParametroFuncao = {
    descricao: "",
    endpointOpcoes: "",
    label: "",
    obrigatorio: false,
    ordem: 0,
    parametroVinculado: "",
    parametros: [],
    tamanhoMaximoExibicao: 0,
    tipo: undefined,
    variavel: ""
  };
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() value: any;
  @Input() readonly = false;

  public formControl = new FormControl();
  public required: boolean;

  ngOnInit(): void {
    this.formControl = new FormControl(null, this.schema.obrigatorio? Validators.required : null);
    this.formGroup.addControl(this.schema.variavel, this.formControl);

    this.required = this.schema.obrigatorio || this.schemaParent.obrigatorio;

    this.formControl.setValue(this.value);

    if (this.readonly) {
      this.formControl.disable();
    }
  }
}
